export const DEFAULT_PURCHASE_MONTHS = 12;

// Date locale : toISOString() passe en UTC et recule d'un jour entre minuit et 1 h / 2 h (heure de Paris)
const toIsoDate = (date: Date): string =>
    [date.getFullYear(), date.getMonth() + 1, date.getDate()].map(part => String(part).padStart(2, '0')).join('-');

export const lastMonthsRange = (months: number): string => {
    const to = new Date();
    // Jour ramené au dernier jour du mois visé : setMonth() déborderait (31 mars - 1 mois = 3 mars)
    const lastDayOfTargetMonth = new Date(to.getFullYear(), to.getMonth() - months + 1, 0).getDate();
    const from = new Date(to.getFullYear(), to.getMonth() - months, Math.min(to.getDate(), lastDayOfTargetMonth));
    return `${toIsoDate(from)}|${toIsoDate(to)}`;
};

export const parseMonthsFromRange = (value: unknown): number | null => {
    if (typeof value !== 'string' || !value.includes('|')) return null;
    const [min, max] = value.split('|').map(raw => new Date(raw));
    if (Number.isNaN(min.getTime()) || Number.isNaN(max.getTime())) return null;
    const months = (max.getFullYear() - min.getFullYear()) * 12 + (max.getMonth() - min.getMonth());
    return months > 0 ? months : null;
};
